import React from 'react'
import { ApolloProvider as Provider } from '@apollo/client'
import { apolloPrismicClient } from 'lib/prismic'

export const ApolloProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider client={apolloPrismicClient}>
      {children}
    </Provider>
  )
}
